import { ICurrentUser } from "../../shared/models/interfaces/current-user";
import { createAction, props, Action } from '@ngrx/store';

export const SET_CURRENT_USER = "[Current User] Set Current User";
export const CLEAR_CURRENT_USER = "[Current User] Clear Current User";

export const SetCurrentUser = createAction(
  SET_CURRENT_USER,
  props<{ payload: ICurrentUser }>()
);

export const ClearCurrentUser = createAction(
  CLEAR_CURRENT_USER
);

export type CurrentUserActions =
  | ReturnType<typeof SetCurrentUser>
  | ReturnType<typeof ClearCurrentUser>;